<!-- 巡逻计划新建面板 优化后 -->
<template>
  <div class="control-right" :class="{ 'control-right-show': isRightShow }">
    <div class="blur-bg map-blur-panel"></div>
    <div class="header">{{ editTypeMap[editType] }}</div>
    <div class="control-right-panel flex-valign">
      <div class="panel-base flex-valign flex-auto" v-if="editType === 1 || editType === 2">
        <el-form style="height: 100%" :inline="true" :model="taskInfo" :rules="rules" ref="refForm" label-width="92px"
          label-position="right" label-suffix="：">
          <el-scrollbar style="height: 100%">
            <el-col :span="24">
              <el-form-item label="布控名称" prop="controlName">
                <el-input type="text" style="width: 100%" v-model="taskInfo.controlName" :maxlength="50"
                  placeholder="请输入布控名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="开始时间" prop="controlStartTime">
                <el-date-picker v-model="taskInfo.controlStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="结束时间" prop="controlEndTime">
                <el-date-picker v-model="taskInfo.controlEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="布控类型" prop="controlSubType">
                <el-select style="width: 100%" v-model="taskInfo.controlSubType" placeholder="请选择"
                  @change="queryFaceGroup">
                  <el-option v-for="item in vehicleGroup" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="布控对象" prop="selectedGroupList">
                <el-select v-model="taskInfo.selectedGroupList" placeholder="请选择" :multiple="editType == 1 ? true : false"
                  style="width: 100%" collapse-tags>
                  <el-option v-for="item in personList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              <el-form-item label="阈值" prop="confidenceThreshold">
                <el-slider style="z-index: 1" v-model="taskInfo.confidenceThreshold"></el-slider>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="摄像机" prop="cameraListCopy" class="camerItem">
                <span style="font-size: 14px; cursor: pointer" type="text" class="el-icon-circle-plus-outline"
                  @click="addCamera">
                  添加</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="camera-content map-blur-panel__content--active">
                <el-scrollbar class="full-height">
                  <div class="p10">
                    <ul>
                      <li v-for="(cameraInfo, ind) in taskInfo.cameraList" :key="ind" class="flex-between">
                        <div class="mb10">
                          <span class="f12 iconfont-lunan icon-lunan-shexiangji"></span>
                          <span class="camera-name ml5">{{
                            cameraInfo.deviceName
                          }}</span>
                        </div>
                        <div class="point-icon">
                          <span class="icon iconfont icon-gray icon-shanchu ml5" title="删除"
                            @click="deleteCamera(ind)"></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </el-scrollbar>
              </div>
            </el-col>
            <el-col :span="24">
              <el-form-item label="布控描述" prop="desc"> </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-input style="margin: -10px 10px 10px; width: 94%" type="textarea" :rows="4" placeholder="请输入"
                :maxlength="200" show-word-limit v-model="taskInfo.desc"></el-input>
            </el-col>
          </el-scrollbar>
        </el-form>
      </div>
      <!-- 布控详情 -->
      <div class="panel-base flex-valign flex-auto detail-list" v-else-if="editType === 3">
        <el-scrollbar class="full-height">
          <div class="flex-row mb25">
            <label class="detail-list_label">布控名称：</label>
            <span>{{ rowInfo.controlName }}</span>
          </div>
          <div class="flex-row mb25">
            <label class="detail-list_label">开始时间：</label>
            <span>{{ rowInfo.controlStartTime }}</span>
          </div>
          <div class="flex-row mb25">
            <label class="detail-list_label">结束时间：</label>
            <span>{{ rowInfo.controlEndTime }}</span>
          </div>
          <div class="flex-row mb25">
            <label class="detail-list_label">布控类型：</label>
            <span>{{ rowInfo.controlSubTypeLabel }}</span>
          </div>
          <div class="flex-row mb25">
            <label class="detail-list_label">布控对象：</label>
            <span>{{ rowInfo.repositoriesName }}</span>
          </div>
          <!-- <div class="flex-row mb25">
            <label class="detail-list_label">阈值：</label>
            <span>{{ rowInfo.confidenceThreshold }}</span>
          </div> -->
          <div class="flex-row mb25">
            <label class="detail-list_label">摄像机：</label>
            <span @click="openVideo(rowInfo, 'live')" class="mr5" style="cursor: pointer; color: #407aee">{{
              rowInfo.deviceName }}</span>
          </div>
          <div class="flex-row">
            <label class="detail-list_label">布控描述：</label>
            <span>{{ rowInfo.desc }}</span>
          </div>
        </el-scrollbar>
      </div>
      <!-- </div> -->
      <!-- 底部按钮 -->
    </div>
    <div class="bottom-btn flex-center p10">
      <div>
        <el-button @click="handleCancelClick" type="info" :loading="addLoading">{{
          addLoading ? "提交中" : editType !== 3 ? "取消" : "关闭"
        }}</el-button>
        <el-button type="primary" v-if="editType !== 3" @click="handleSaveClick" :loading="addLoading">{{ addLoading ?
          "提交中" : "保存" }}</el-button>
      </div>
    </div>
    <!-- 面板拉手 -->
    <div class="control-list-toolbar" :class="{ changeLeft: !isRightShow }" v-show="isShow">
      <div v-show="!isRightShow" style="left: 0"
        class="map-blur-panel__expand-button right iconfont-lunan icon-lunan-shousuocaidan-copy"
        @click="showPlanListPanel"></div>
      <div v-show="isRightShow" style="left: 0"
        class="map-blur-panel__expand-button right iconfont-lunan icon-lunan-shousuocaidan" @click="showPlanListPanel">
      </div>
    </div>
    <!-- 摄像机树组件 -->
    <appPanel :width="350" class="app-panel" :isExpand="cameraVisible" @cancel="cancelCamera" title="摄像机组">
      <area-device-tree ref="deviceTree" @cameraData="getCameraData" :multiCheck="true" :showPercentage="true"
        :defaultCheckedKeys="cameraIdList">
      </area-device-tree>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="cancelCamera" type="info">取消</el-button>
        <el-button @click="confirmCamera" type="primary">确定</el-button>
      </div>
    </appPanel>
    <!-- 布控类型 -->
    <div class="camera-tip p5 map-blur-panel">
      <div class="m10 valign-center">
        <img src="@public/images/theme/newDark/map/resource/controlled_select.png" class="mr10 camera-img" />
        <span>已布控</span>
      </div>
      <div class="m10 valign-center">
        <img src="@public/images/theme/newDark/map/camera2.png" class="mr10 camera-img" />
        <span>未布控</span>
      </div>
      <div class="m10 valign-center">
        <img src="@public/images/theme/newDark/map/camera-Active.png" class="mr10 camera-img" />
        <span>已选中</span>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import appPanel from "@src/components/business/app-panel/index.vue";
import areaDeviceTree from "./app-area-list";
import { Dic, Cache } from "$utils";

export default {
  name: "control-right-car",
  components: {
    areaDeviceTree,
    appPanel,
  },
  props: {
    selectedDeviceInfo: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      checkCameraList: [],
      checkNodeInfo: {},
      editType: 1,
      isShow: false, //右侧按钮
      isRightShow: false, //右侧面板
      tipShow: false,
      expandType: false,
      editTypeMap: {
        1: "创建布控",
        2: "修改布控",
        3: "布控详情",
      },
      addLoading: false,
      taskInfo: {
        controlName: "",
        controlType: "2",
        controlSubType: null,
        groupList: [],
        confidenceThreshold: Number(Cache.get("SYS_YUZHI")),
        desc: "",
        cameraList: [],
        cameraListCopy: "",
        vehicleNames: "",
        stackingTime: 40,
        vehicleTime: 50,
        faceTracking: false,
        selectedGroupList: [],
      },
      // selectedGroupList: [],
      cameraIdList: [],
      typeOptions: [],
      hitType: [
        {
          label: "命中布控",
          value: 1,
        },
        {
          label: "非命中布控",
          value: 2,
        },
      ],
      personGroup: Dic.find("SENU090"),
      vehicleGroup: Dic.find("SENU091"),
      personList: [],
      vehicleGroupList: [],
      cameraVisible: false,
      cameraIndex: 1,
      rowInfo: {
        controlType: "2", //'布控分类,1,表示人员布控 2,表示车辆布控,3,周界入侵布控,4,消防通道占用布控',
        hitType: "1", //命中类型,1，表示命中布控 2，表示非命中布控,默认命中布控
        controlName: "1", //布控名称
        confidenceThreshold: "1", //布控阈值 0 ~ 100;设定默认阈值为85
        desc: "1", //'描述，长度1-255',
        groupNames: "", //布控对象 逗号分隔
        deviceName: "1", //摄像机名称
        stackingTime: 0,
        vehicleTime: 0,
      },
      newCameraData: [],
      rules: {
        controlName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"],
          },
        ],
        controlStartTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: ["blur", "change"],
          },
        ],
        controlEndTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: ["blur", "change"],
          },
        ],
        controlSubType: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["blur", "change"],
          },
        ],
        selectedGroupList: [
          {
            required: true,
            message: "请选择对象",
            trigger: ["blur", "change"],
          },
        ],
        confidenceThreshold: [
          {
            required: true,
            message: "请选择阈值",
            trigger: ["blur", "change"],
          },
        ],
        cameraListCopy: [
          {
            required: true,
            message: "请选择摄像机",
            trigger: ["change"],
          },
        ],
      },
    };
  },
  watch: {
    selectedDeviceInfo(newVal, oldVal) {
      console.log(newVal);
      this.taskInfo.cameraList = [];
      this.cameraIdList = [];
      newVal.forEach((item) => {
        this.taskInfo.cameraList.push({
          deviceName: item.attr.deviceName,
          deviceId: item.id,
          thirdDeviceId: item.attr.thirdDeviceId,
          areaSetting: item.attr.areaSetting
            ? item.attr.areaSetting
            : {
              polygons: [],
              lines: [],
            },
        });
        this.cameraIdList.push(item.id); //回显摄像机组里面的摄像机id
      });
      this.$nextTick(() => {
        if (this.cameraIdList.length) {
          this.taskInfo.cameraListCopy = "add";
          this.$refs.refForm.clearValidate("cameraListCopy");
        } else {
          this.taskInfo.cameraListCopy = "";
        }
        this.$refs.deviceTree.$refs.appAreaTree.setCheckedKeys(
          this.cameraIdList
        );
      });
    },
  },
  created() { },
  mounted() {
    this.typeOptions = Dic.find("SENU081").filter((item) => {
      return item.value;
    });
  },
  methods: {
    showPlanListPanel() {
      this.isRightShow = !this.isRightShow;
    },
    open(editType, rowInfo = {}) {
      console.log("右侧数据", rowInfo);
      this.editType = editType;
      if (this.editType === 1) {
        // 新增
        // this.handleCancelClick();
      } else if (this.editType === 2) {
        // 修改
        this.queryFaceGroup(Number(rowInfo.controlSubType), true);
        this.taskInfo = {
          controlName: rowInfo.controlName,
          controlType: Number(rowInfo.controlType),
          controlSubType: Number(rowInfo.controlSubType),
          groupList:
            rowInfo.controlType == 1
              ? rowInfo.faceGroups
              : rowInfo.vehicleGroups,
          confidenceThreshold: Number(rowInfo.confidenceThreshold),
          desc: rowInfo.desc,
          faceTracking: rowInfo.faceTracking,
          faceNames: rowInfo.faceNames,
          vehicleNames: rowInfo.vehicleNames,
          controlGroupCode: rowInfo.controlGroupCode,
          controlCode: rowInfo.controlCode,
          stackingTime: rowInfo.stackingTime,
          vehicleTime: rowInfo.vehicleTime,
          controlStartTime: rowInfo.controlStartTime,
          controlEndTime: rowInfo.controlEndTime,
          selectedGroupList: [],
        };
        this.cameraIdList = [rowInfo.deviceId];
        this.$nextTick(() => {
          this.taskInfo.selectedGroupList = rowInfo.repositoriesCode;
        });
        this.$emit("chooseCamera", this.cameraIdList);
      } else if (this.editType === 3) {
        // 详情
        this.rowInfo = { ...rowInfo };
        if (this.rowInfo.controlType === "2") {
          this.rowInfo.controlSubTypeLabel = Dic.findByValue(
            "SENU091",
            this.rowInfo.controlSubType
          );
        }
        this.$log.info("详情---布控类型", this.rowInfo.controlSubTypeLabel);
        this.rowInfo.controlTypeLabel = Dic.findByValue(
          "SENU081",
          this.rowInfo.controlType
        );
      }
      this.isShow = true;
      this.isRightShow = true;
    },
    handleCancelClick() {
      if (this.editType != 3) {
        this.$refs.refForm.resetFields();
      }
      this.isShow = false;
      this.isRightShow = false;
      this.$emit("closeRight");
    },
    handleSaveClick() {
      this.updatePlan();
    },
    updatePlan() {
      console.log(this.taskInfo);
      this.$refs.refForm.validate((res) => {
        if (res) {
          if (this.editType == 1) {
            this.taskInfo.groupList = this.taskInfo.selectedGroupList.map(
              (item) => {
                return { repositoriesCode: item };
              }
            );
          } else {
            this.taskInfo.groupList = [
              { repositoriesCode: this.taskInfo.selectedGroupList },
            ];
          }

          this.addLoading = true;
          const url =
            this.editType == 1 ? api.addControlTask : api.updateControlTask; //1 新增，2 编辑
          this.$fetch(url, this.taskInfo).then((res) => {
            this.addLoading = false;
            if (res.success) {
              this.$message.success(
                `${this.editType == 1 ? "创建" : "修改"}成功`
              );
              this.$refs.refForm.resetFields();
              this.isShow = false;
              this.isRightShow = false;
              this.$emit("saveSuccess");
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },

    // 打开摄像机组
    addCamera() {
      this.cameraVisible = true;
      this.$refs.deviceTree.$refs.appAreaTree.setCheckedKeys(this.cameraIdList);
    },
    getCameraData(data) {
      console.log(data);
      this.checkCameraList = [...data];
      // this.
    },
    // 摄像机选中回调
    confirmCameraData(data) {
      console.log("点击的摄像机", data);
      let layerId = "cameraId";
      this.cameraIdList.forEach((item) => {
        let check = this.selectedDeviceInfo.filter((el) => {
          return el.id == item;
        });

        if (check.length != 0) {
          this.$map.MapInstance2D.updateFeatureById(
            layerId, //未布控摄像机图层,
            layerId + "-" + item,
            {
              src: check[0].attr.oldSrc,
            }
          );
        }
      });
      setTimeout(() => {
        this.newCameraData = [].concat(data);
        this.cameraIdList = [];
        // 新创建的摄像机
        data.forEach((item) => {
          this.$map.MapInstance2D.updateFeatureById(
            layerId, //未布控摄像机图层,
            layerId + "-" + item.id,
            {
              src: "/images/theme/newDark/map/camera-Active.png",
            }
          );
          // 回显至已选中摄像机数组
          this.cameraIdList.push(item.id);
        });
        if (this.cameraIdList.length) {
          this.taskInfo.cameraListCopy = "add";
          this.$refs.refForm.clearValidate("cameraListCopy");
        } else {
          this.taskInfo.cameraListCopy = "";
        }
        this.$emit("chooseCamera", this.cameraIdList);
      }, 200);
    },
    cancelCamera() {
      this.cameraVisible = false;
      this.checkCameraList = [];
    },
    confirmCamera() {
      this.confirmCameraData([...this.checkCameraList]);
      this.cancelCamera();
    },
    // 打开视频播放组件
    openVideo(cameraInfo, type) {
      // console.log(cameraInfo)
      this.$app.AppInstance.handleMiniPlay({
        playType: type,
        playTitle: cameraInfo.deviceName, //摄像机名称
        playId: cameraInfo.thirdDeviceId, //摄像机id
      });
    },
    deleteCamera(ind) {
      let layerId = "cameraId";
      let checkDevice = this.cameraIdList.splice(ind, 1);
      console.log(checkDevice);
      this.selectedDeviceInfo.forEach((el) => {
        if (checkDevice == el.id) {
          // 取消选中
          this.$map.MapInstance2D.updateFeatureById(
            layerId, //未布控摄像机图层,
            layerId + "-" + checkDevice,
            {
              src: el.attr.oldSrc,
            }
          );
        }
      });
      this.$emit("deleteCamera", ind);
    },
    queryFaceGroup(type) {
      this.taskInfo.selectedGroupList = [];
      this.$fetch(api.queryVehicleGroupByType, {
        type: type,
      }).then((res) => {
        if (res.success) {
          if (res.returnObj && res.returnObj.list.length) {
            this.personList = res.returnObj.list.map((item) => {
              return { label: item.name, value: item.code };
            });
          }
          this.$log.info("车辆布控对象", this.personList);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
:deep .el-scrollbar__thumb {
  width: 0 !important;
}

.camerItem {
  :deep .el-form-item__error {
    // position: relative;
    left: -80px;
    top: 130px;
  }
}
</style>
<style lang="scss">
.el-col {
  .el-form-item {
    display: flex;
    width: 100%;

    .el-form-item__content {
      width: calc(100% - 95px);
    }
  }
}

.el-slider__button-wrapper {
  z-index: 1;
}

.app-panel {
  top: 0;
}

@import "../style/control-right.scss";
</style>
